import { GridCsvExportOptions } from "@mui/x-data-grid";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import {
  setExportOptions,
  setProccessEnded,
  setShowWhatsAppConfirmation,
} from "src/redux/qualify_for_habi/qualifyForHabi.slice";
import {
  getPropertiesQualifyForHabi,
  postSaveHistory,
  postSendWhatsApp,
} from "src/redux/qualify_for_habi/qualifyForHabi.thunks";
import {
  selectLoading,
  selectMessagesInfo,
  selectProcessEnded,
  selectrowSelectedWhatsapp,
  selectRowsSelected,
  selectUniqueValues,
  selectWhatsapp,
} from "src/redux/qualify_for_habi/selects";

export const useCustomBar = ({ apiRef }) => {
  const dispatch = useAppDispatch();
  const uniqueValuesCount = useAppSelector(selectUniqueValues);
  const qualify: { messages_sended?: number, messages_error?: number } = useAppSelector(selectMessagesInfo)
  const rowSelected = useAppSelector(selectrowSelectedWhatsapp);
  const loading = useAppSelector(selectLoading)
  const process_ended = useAppSelector(selectProcessEnded)
  const { rowsSelected } = useAppSelector(selectRowsSelected);
  const { loading_whatsapp: loadingWhastApp } = useAppSelector(selectWhatsapp);

  const getRowsSelected = () => {
    return rowsSelected;
  };
  const handleExport = async (options: GridCsvExportOptions) => {
    options.fileName = `leads-calificados-${new Date().toISOString()}`;
    apiRef.current.exportDataAsCsv(options);
    await dispatch(postSaveHistory());
    clearSelected();
    dispatch(
      setShowWhatsAppConfirmation({
        open: true,
        message: "Exportación y cambio de estado exitoso.",
      })
    );
    dispatch(getPropertiesQualifyForHabi());
  };
  const clearSelected = () => {
    rowsSelected?.forEach((row) => {
      apiRef.current.selectRow(row, false);
    });
  };
  const handleSendWhatsApp = async () => {
    const size = 4
    let promiseArray = []
    dispatch(setProccessEnded(false))
    dispatch(setShowWhatsAppConfirmation({
      open: true,
      message: `Enviados ${qualify.messages_sended} mensajes de ${rowSelected.length}`,
      loading_whatsapp: true
    }))
    for (let i = 0; i < rowSelected.length; i += size) {
      const groups = rowSelected.slice(i, i + size);
      let payload = [];
    
      if (Array.isArray(groups)) {
        groups.forEach(subgroup => {
          if (Array.isArray(subgroup)) {
            subgroup.forEach(item => {
              payload.push(item);
            });
          } else {
            payload.push(subgroup);
          }
        });
      }
      promiseArray.push(postSendWhatsApp(payload));
    }
    
    await Promise.allSettled(
      promiseArray.map(promise => dispatch(promise))
    );
    dispatch(setProccessEnded(true))
  };

  useEffect(() => {
    if (process_ended) {
      dispatch(setShowWhatsAppConfirmation({
        open: true,
        message: `Se enviaron ${qualify.messages_sended} mensajes de ${rowSelected.length}.`,
        loading_whatsapp: false
      }))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [process_ended])

  const handleSetSource = (source) => {
    let exportOptions = {};
    switch (source) {
      case "0":
        exportOptions = {
          source: null,
          status: 2,
        };
        break;
      case "1":
        exportOptions = {
          source: 2,
          status: 3,
        };
        break;
      case "2":
        exportOptions = {
          source: 3,
          status: 3,
        };
        break;
    }
    dispatch(setExportOptions(exportOptions));
  };

  return {
    getRowsSelected,
    handleExport,
    handleSendWhatsApp,
    handleSetSource,
    rowsSelected,
    loadingWhastApp,
    uniqueValuesCount,
    apiRef,
    loading,
    qualify
  };
};
